let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9tO7t")).then(() => parcelRequire('eJS3k'));